// extracted by mini-css-extract-plugin
module.exports = {"container":"r","overlay":"s","headingSection":"t","close":"u","copy":"v","m-heart-activate":"w","bottomSection":"x","signInButton":"y","disabled":"z","m-heart-pulse":"A"};